/**
 * List of iytxtbs values that appear in more than one paragraph in the source XML.
 * Used by XML block import to optionally exclude duplicate blocks from import.
 * Source: duplicate-iytxtbs-report.txt (193 values).
 */
export const DUPLICATE_IYTXTBS = new Set([
  '0000', '00000', '0001', '0002', '0003', '00099', '0010', '0011', '0012', '0013', '0014', '0015', '0016', '0017', '0018', '0019',
  '0025', '0026', '0027', '0028', '0030', '00400', '0044', '0079', '0100', '0101', '0102', '0107', '0111', '0116', '0117', '0118',
  '0125', '0126', '0200', '0201', '0202', '0203', '0204', '0205', '0206', '0207', '0209', '0210', '0211', '0212', '0213', '0215', '0216', '0217', '0218', '0219', '0220', '0221', '0222', '0223', '0224',
  '0300', '0311', '0400', '0401', '0500', '0501', '0502', '0601', '0602', '0603', '0604', '0605', '0606', '0610',
  '0700', '0701', '0702', '0703', '0704', '0705', '0800', '0802', '09999',
  '1500', '2100', '2160', '2161', '2195', '2200', '2202', '2500', '2501', '2505', '2506', '2507', '2508', '2509',
  '2600', '2601', '2800', '2801', '2901', '2902', '2903', '2905', '2906', '2907',
  '3000', '30000', '3001', '3002', '3003', '3004', '3009', '3010', '3210', '3211', '3212',
  '3500', '3501', '3502', '3503', '3504', '4000', '4010', '4011', '4012', '4013', '4014', '4015', '4016', '4020', '4021', '4022', '4023',
  '4030', '4031', '4032', '4033', '4094', '4110', '4116', '4117', '4118', '4133',
  '50011', '50012', '50110', '51907', '58888', '59990', '59991', '59998', '59999', '61361', '61660', '62433',
  '69990', '69991', '69992', '69993', '69994', '69995', '69996', '69997', '69998', '69999',
  '7000', '70842', '75011', '76660', '79990', '79991', '79992', '79998', '79999', '80036', '88002', '88026', '89995',
  '9000', '90000', '90001', '9001', '9002', '95934', '99900', '9998', '99985', '99986', '99988', '99990', '99991',
  'A0038', 'F0012', 'F0025',
]);
